// removed by extract-text-webpack-plugin
module.exports = {"resultContainer":"_1pI0TIiU5tAoqqEBNOG9NL","eventTime":"_3I0ol1Yk20WCAt4d--4_Qg","result":"_2kJ6qsUDFkx37VOHbTsytH","teamName":"_3rOIJMpbHQnNnoTEHmWTEe","cricketTitle":"_1LerdWlkNb8gO4OKlHjHIU","even":"_1H7QCIDclJnbSvrYomixWd","eventDetailsWrapper":"_2xo6D3jdU6ajE4mepfqgxf","eventDetails":"_3qytI8qJ302_XAHEPMgQQT","eventDetailsLine":"_3BhONXWWSAmKyOxKo9u0QN","eventDetailsLineLeft":"_26IvA78C4Xez9ijgpLlIEL","eventDetailsLineRight":"_3HxBSQur8tSBVlTUxhq-3Y"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/lockedBetCricket.css
// module id = 219
// module chunks = 0